/**
 * public.public_store_profiles — ACTIVE stores only, non-sensitive columns.
 * Use this instead of "Stores" for public/anonymous reads.
 */
export const PUBLIC_STORE_PROFILES = "public_store_profiles" as const;

export type PublicStoreProfileRow = {
  id: string;
  name: string;
  slug: string | null;
  summary: string | null;
  email: string | null;
  phone_number: string | null;
  banner_pic: string | null;
  zip: number | string | null;
  business_type: string | null;
  operation_hours: unknown;
  delivery_radius: number | null;
  payment_terms: string | null;
  contact_name: string | null;
  offers_shipping: boolean | null;
  created_at: string;
  updated_at: string;
};
